import PropTypes from 'prop-types'
import React from 'react'
import useTranslation from 'next-translate/useTranslation'

export const RegistrationPriceMobile = ({price}) => {
  const { t } = useTranslation('common')

  if (!price) return null

  return (
    <div className='oglasi-opis'>
      <div className='oglasi-info-heading'>
        <p>{t('Cijena registracije')}</p>
      </div>
      <p>{t('cijena-registracije-tekst')} <span className='registracija-info-cijena'>{price} &euro;</span>
      </p>
    </div>
  )
}

RegistrationPriceMobile.propTypes = {
  price: PropTypes.string
}
